/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons';

const style = {
  fontSize: '1.8em',
  verticalAlign: '-20%',
};

const NextIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAngleRight} style={style} {...props} />
);

export default NextIcon;
